import CompleteIcon from './component.jsx'
export default CompleteIcon
